module.exports = __webpack_public_path__ + "img/fresh-registration-details-bg.c40316ac.png";